var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5061 74.6634C41.0822 78.2396 45.4121 80.5893 49.9783 81.6976C43.8767 61.8093 62.5196 43.0986 82.4598 49.2162C81.3514 44.6499 79.0017 40.32 75.4256 36.7439C64.9334 26.2517 47.9538 26.2664 37.4913 36.729C27.0286 47.1916 27.0139 64.1713 37.5061 74.6634Z",
    fill: "#FF61D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2158 52.5222L53.3759 66.3621C46.6078 63.1621 30.5759 55.0821 20.6238 46.2661C17.5198 43.5142 15.3759 40.1541 13.9038 36.5861C22.7998 30.3142 30.6398 22.4422 37.4238 13.0342C40.9919 14.5062 44.3679 16.6501 47.1198 19.7541C55.9358 29.7222 64.0158 45.7541 67.2158 52.5222Z",
    fill: "#B431FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7657 65.5693C45.3566 62.9204 36.8704 58.493 29.2129 53.3335L50.7657 65.5693Z",
    fill: "#B431FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5893 65.9279C44.9127 63.1482 36.558 58.7654 28.9893 53.6654L29.4361 53.0029C36.9674 58.0764 45.2877 62.4404 50.9424 65.2092L50.5893 65.9279Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2202 28.3037C59.4013 35.9809 63.8491 44.505 66.5066 49.9318L54.2202 28.3037Z",
    fill: "#B431FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1475 50.1076C63.3646 44.4248 58.9787 36.0701 53.8896 28.5279L54.5521 28.0811C59.6678 35.6592 64.0725 44.0514 66.8662 49.7545L66.1475 50.1076Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4239 13.0344C30.6399 22.4424 22.7999 30.3144 13.9039 36.5863C10.8211 29.1432 10.3504 19.5028 11.392 12.2184C11.5199 11.2743 11.6159 10.7623 11.6159 10.7623C22.2519 9.14183 31.2606 10.4852 37.4239 13.0344Z",
    fill: "#FEB7FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3643 37.2388L13.4424 35.9325C22.1924 29.7638 30.0424 21.9028 36.7752 12.5669L38.0721 13.5013C31.2361 22.9825 23.2596 30.9685 14.3643 37.2388Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6555 55.0781L71.964 58.2218L59.0796 71.1063L56.1558 63.5778L64.6555 55.0781Z",
    fill: "#FF61D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9997 65.7511L56.1558 63.5779L64.6555 55.0781L66.7652 55.9856L56.9997 65.7511Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0104 50.3299C45.7059 50.3299 51.1336 44.9022 51.1336 38.2067C51.1336 31.5112 45.7059 26.0835 39.0104 26.0835C32.3149 26.0835 26.8872 31.5112 26.8872 38.2067C26.8872 44.9022 32.3149 50.3299 39.0104 50.3299Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5481 44.1736C45.8728 50.9986 36.1977 52.5442 30.4386 46.7851C30.0605 46.407 29.7002 45.9927 29.4121 45.5785C33.0278 38.8625 42.6731 37.1408 48.5214 42.9669C48.8996 43.3451 49.2598 43.7594 49.5481 44.1736Z",
    fill: "#00E05E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8325 69.3534C66.7009 75.463 76.5232 75.799 76.5232 75.799C76.5232 75.799 76.4085 65.7558 70.5399 59.646L60.8325 69.3534Z",
    fill: "#FFDF51"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.569 59.1841L60.5322 70.2209L71.569 59.1841Z",
    fill: "#B431FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2363 69.9385L71.2723 58.9025L71.8379 59.4681L60.8019 70.5041L60.2363 69.9385Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5771 85.9436L62.9287 78.9357L63.51 78.3857L70.1584 85.3936L69.5771 85.9436Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6535 85.5028L71.8613 78.8731L72.4207 78.3013L79.2129 84.931L78.6535 85.5028Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6115 79.9218C83.4834 78.2421 81.3975 76.4515 79.4131 74.6015L79.96 74.0171C81.9271 75.8515 83.9959 77.6265 86.1084 79.2937L85.6115 79.9218Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3909 69.2344C83.2159 67.625 81.0753 65.9016 79.0269 64.1109L79.555 63.5078C81.5862 65.2844 83.7097 66.9953 85.8659 68.5906L85.3909 69.2344Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3018 35.2969L31.9962 34.9001L35.6229 41.2469L34.9285 41.6437L31.3018 35.2969Z",
    fill: "#00E05E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1448 35.6064C34.1448 36.759 33.2084 37.6956 32.0556 37.6956C30.921 37.6956 29.9844 36.759 29.9844 35.6064C29.9844 34.4537 30.921 33.5352 32.0556 33.5352C33.2084 33.5352 34.1448 34.4537 34.1448 35.6064Z",
    fill: "#00E05E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7622 40.9214L46.3955 34.5759L47.0897 34.9735L43.4565 41.3189L42.7622 40.9214Z",
    fill: "#00E05E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2368 35.2641C44.2368 36.4167 45.1733 37.3533 46.326 37.3533C47.4607 37.3533 48.3973 36.4167 48.3973 35.2641C48.3973 34.1114 47.4607 33.1929 46.326 33.1929C45.1733 33.1929 44.2368 34.1114 44.2368 35.2641Z",
    fill: "#00E05E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4423 44.8797C43.4423 47.0658 41.6661 48.8417 39.4801 48.8417C37.294 48.8417 35.5181 47.0658 35.5181 44.8797C35.5181 42.6937 37.294 40.9175 39.4801 40.9175C41.6661 40.9175 43.4423 42.6937 43.4423 44.8797Z",
    fill: "#220057"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4799 44.8796C39.4799 45.7009 38.8126 46.3681 37.9914 46.3681C37.1701 46.3681 36.5029 45.7009 36.5029 44.8796C36.5029 44.0584 37.1701 43.3911 37.9914 43.3911C38.8126 43.3911 39.4799 44.0584 39.4799 44.8796Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9038 62.2559L59.6502 61.9725L61.5369 66.9416L60.7905 67.2249L58.9038 62.2559Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M68.285 60.6796L63.4756 58.414L63.8162 57.689L68.6256 59.9546L68.285 60.6796Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5415 60.7056L62.0724 60.1092L65.1652 62.8625L64.6343 63.4589L61.5415 60.7056Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3413 12.5677C20.0654 12.3843 23.8213 12.8678 27.3776 13.9883L16.3413 12.5677Z",
    fill: "#B431FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2567 14.3703C23.7224 13.2578 20.0567 12.7874 16.3614 12.9671L16.3208 12.1671C20.1271 11.9921 23.8739 12.4671 27.4974 13.6078L27.2567 14.3703Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.478 15.5029C22.8326 15.592 24.1777 15.8251 25.4832 16.1972L21.478 15.5029Z",
    fill: "#B431FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.374 16.5811C24.0975 16.2186 22.7771 15.9889 21.4521 15.9014L21.5053 15.1045C22.8865 15.1951 24.2615 15.4326 25.5928 15.8123L25.374 16.5811Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.69aa79bf7630a676507c483c5c5a8413.svg";
export { ForwardRef as ReactComponent };